module.exports = __webpack_public_path__ + "img/9ne.0e0f141f.svg";